import React from 'react';
import { Route } from 'react-router-dom';

import { Settings } from './Settings';
import { AccountPage } from './AccountPage';
import { ProfilePage } from './ProfilePage';
import { SubscriptionPage } from './subscription/SubscriptionPage';
import { UsersPage } from './UsersPage';
import { InvoicingPage } from './invoicing/InvoicingPage';
import TemplatesPage from './templates/TemplatesPage';
import TermsPage from './TermsPage';
import { VatRatesPage } from './vat-rates/VatRatesPage';
import { BankDetailsPage } from './BankDetailsPage';
import Warehousing from '../warehousing/Warehousing';

import { IntegrationsPage } from './integrations/IntegrationsPage';

export default function SettingsRouter() {
  return (
    <>
      <Route exact path="/settings" component={Settings} />
      <Route path="/settings/account" component={AccountPage} />
      <Route path="/settings/subscription" component={SubscriptionPage} />
      <Route path="/settings/users" component={UsersPage} />
      <Route path="/settings/profile" component={ProfilePage} />
      <Route path="/settings/warehousing" component={Warehousing} />
      <Route path="/settings/invoicing" component={InvoicingPage} />
      <Route path="/settings/templates" component={TemplatesPage} />
      <Route path="/settings/vat-rates" component={VatRatesPage} />
      <Route path="/settings/bank-details" component={BankDetailsPage} />
      <Route path="/settings/terms" component={TermsPage} />
      <Route path="/settings/integrations" component={IntegrationsPage} />
    </>
  );
}
